import jump from 'jump.js';

$(document).ready(() => {

  $('.js-product-nav a').on('click', (e) => {

    console.log($(e.currentTarget).closest('li').index())

    let i = $(e.currentTarget).closest('li').index();

    jump($('[data-j="product-nav"]')[i], {
      duration: 500,
      offset: -(($('.g--header').height() * 1.25) + 30)
    });

  });

});